module.exports = __webpack_public_path__ + "img/palmar-room-12.8047a98d.jpg";